var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Field__Component" }, [
    _c(
      "label",
      { attrs: { for: "" } },
      [
        _c("span", [_vm._t("default")], 2),
        _c(
          "v-select",
          {
            attrs: {
              dir: "rtl",
              options: _vm.data,
              clearable: _vm.clearable,
              placeholder: "בחר ערך מהרשימה",
              label: "Text",
              value: _vm.value,
              filter: _vm.filter
            },
            on: { search: _vm.fetchOptions, input: _vm.setSelected }
          },
          [
            _c("div", { attrs: { slot: "no-options" }, slot: "no-options" }, [
              _vm._v("לא נמצאו ערכים דומים")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }